import {
  SessionStorageData,
  SessionStorageKey,
  SessionStorageManager,
} from '@/common/utils/browserStorage/SessionStorageManager';

export const searchTrackingStorageManager = new SessionStorageManager<
  SessionStorageData[SessionStorageKey.SEARCH_TRACKING_METADATA]
>(SessionStorageKey.SEARCH_TRACKING_METADATA);
